import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgFieldClose = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12" {...props}>
    <path
      d="m1.113 10.95 9.9-9.9m-9.873.028 9.9 9.9"
      fill="none"
      stroke="#007AFF"
      strokeWidth={1.04}
    />
  </svg>
);
const Memo = memo(SvgFieldClose);
export default Memo;
